import React from "react";
import { PrestacaoContasProvider } from "./context/prestacao-contas-context";
import { PrestacaoContas } from "./prestacao-contas";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const PrestacaoContasFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Prestação de Contas"}>
            <PrestacaoContasProvider>
                <PrestacaoContas />
            </PrestacaoContasProvider>
        </BaseInternalFormFactory>
    );
};

export default PrestacaoContasFactory;
